import { render, staticRenderFns } from "./emailSent.vue?vue&type=template&id=3f5c5c84&scoped=true&"
import script from "./emailSent.vue?vue&type=script&lang=js&"
export * from "./emailSent.vue?vue&type=script&lang=js&"
import style0 from "./emailSent.vue?vue&type=style&index=0&id=3f5c5c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c5c84",
  null
  
)

export default component.exports